import { useState } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";
import { motion } from "framer-motion";
import { CookiePreferencesModal } from "./CookiePreferenceModal";

export function CookieBanner() {
  const { preferences, updatePreferences } = useCookieConsent();
  const [preference, setPreference] = useState<boolean>(false);
  const [statistics, setStatistics] = useState<boolean>(false);
  const [marketing, setMarketing] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  if (preferences) return null;

  const handleAcceptAll = () => {
    updatePreferences({ statistics: true, marketing: true, preference: true });
  };

  const handleSave = () => {
    updatePreferences({ statistics, marketing, preference });
  };

  const handleRejectAll = () => {
    updatePreferences({
      statistics: false,
      marketing: false,
      preference: false,
    });
  };

  return (
    <div className="max-w-screen-3xl mx-auto z-50 w-[100vw] fixed bottom-3 left-0 right-0 flex justify-center text-primary text-sm leading-5 px-10">
      <div className=" rounded-[30px] bg-[#E0E0D6] text-black py-6 px-6 flex flex-col sm:flex-row justify-between items-center ">
        <div className="flex flex-[5] flex-col gap-3">
          <span className="font-[500]">ESTE SITE UTILIZA COOKIES</span>
          <p className="text-sm font-light">
            Nós usamos cookies para personalizar conteúdo e anúncios, fornecer
            recursos de mídias sociais e analisar o nosso tráfego. Nós também
            compartilharmos informações sobre o seu uso do nosso site com nossos
            parceiros de mídias sociais, publicidade e análises, que podem
            combiná-las com outras informações que você forneceu a eles ou que
            eles coletaram através do seu uso dos serviços deles.
          </p>

          <div className="flex gap-4 flex-wrap">
            <div className="flex  items-center justify-center gap-2">
              <span>Necessários</span>
              <Toogle setState={() => {}} state={true} />
            </div>

            <div className="flex items-center justify-center gap-2">
              <span>Preferências</span>
              <Toogle setState={setPreference} state={preference} />
            </div>

            <div className="flex items-center justify-center gap-2">
              <span>Estatisticas</span>
              <Toogle setState={setStatistics} state={statistics} />
            </div>

            <div className="flex items-center justify-center gap-2">
              <span>Marketing</span>
              <Toogle setState={setMarketing} state={marketing} />
            </div>

            <button
              className="underline text-secondary"
              onClick={() => setShowModal(true)}
            >
              {"Exibir detalhes ->"}
            </button>
          </div>
        </div>
        <div className="mt-2 sm:mt-0 flex flex-col gap-2 flex-[1] items-end w-full">
          <button
            type="button"
            className="w-full md:w-[230px] rounded border border-secondary px-4 py-1 text-sm transition-all duration-300 bg-secondary text-white"
            onClick={handleAcceptAll}
          >
            Permitir Todos
          </button>
          <Button label="Permitir Seleção" onClick={handleSave} />
          <Button label="Negar" onClick={handleRejectAll} />
        </div>
        {showModal && (
          <CookiePreferencesModal onClose={() => setShowModal(false)} />
        )}
      </div>
    </div>
  );
}

const Toogle = ({
  state,
  setState,
}: {
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div
      className={`relative w-[40px] h-[20px] rounded-full cursor-pointer p-1 flex items-center transition-colors ${
        state ? "bg-secondary" : "bg-[#ACB2B6]"
      }`}
      onClick={() => setState(!state)}
    >
      <motion.div
        className="size-4 bg-white rounded-full shadow-md"
        layout
        initial={false}
        animate={{ x: state ? 18 : -1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      />
    </div>
  );
};

const Button = ({ label, onClick }: { label: string; onClick: () => void }) => {
  return (
    <button
      type="button"
      className="bg-transparent w-full md:w-[230px] rounded border border-secondary text-secondary px-4 py-1 text-sm transition-all duration-300 hover:bg-secondary hover:text-white"
      onClick={onClick}
    >
      {label}
    </button>
  );
};
